"use strict";
var debounce = require("lodash/debounce");
var processInclude = require("./util");

$(document).ready(function () {
    processInclude(require("./global/initFlowbox"));

    // edit mode stop sticky header
    if ($(".js-pd-in-edit-mode").length) {
        $(".l-header").attr("style", "position: relative !important");
        $("div:has([data-mock-component]):last").empty().addClass("pd-mock-component");
    }

    // banner button hover attibutes
    var $bannerButton = $(".js-banner-button, .js-custom-styled-pd-button");

    if ($bannerButton.length) {
        $bannerButton.on("mouseenter", function () {
            var $this = $(this);
            if ($this.data("hovercolor") && $this.data("hovercolor").length) {
                $this.css("color", $this.data("hovercolor"));
            }
            if ($this.data("borderhovercolor") && $this.data("borderhovercolor").length) {
                $this.css("border-color", $this.data("borderhovercolor"));
            }
            if ($this.data("backgroundhovercolor") && $this.data("backgroundhovercolor").length) {
                $this.css("background", $this.data("backgroundhovercolor"));
            }
        });
        $bannerButton.on("mouseleave", function () {
            var $this = $(this);
            if ($this.data("color") && $this.data("color").length) {
                $this.css("color", $this.data("color"));
            }
            if ($this.data("bordercolor") && $this.data("bordercolor").length) {
                $this.css("border-color", $this.data("bordercolor"));
            }
            if ($this.data("backgroundcolor") && $this.data("backgroundcolor").length) {
                $this.css("background", $this.data("backgroundcolor"));
            }
        });
    }

    // pd filter list
    const $filterGroups = $(".js-pd-filter-group");

    if ($filterGroups.length) {
        const $filterFilterButtons = $(".js-pd-filter-button");

        $filterFilterButtons.on("click", function () {
            const $filterButton = $(this);
            const externalURL = $filterButton.data("external-url");

            if (externalURL && externalURL.length) {
                window.location.href = externalURL;
                return;
            }

            const $filterGroup = $filterButton.closest(".js-pd-filter-group");
            const filterGroupId = $filterGroup.data("filter-groupid");
            const filterId = $filterButton.data("filterid");

            $filterGroup.find(".js-pd-filter-button").removeClass("selected");
            $filterButton.addClass("selected");

            const $groupsToFilter = $(`[data-groupid=${filterGroupId}]`);

            if ($groupsToFilter.length > 0) {
                if (filterId === "all") {
                    $groupsToFilter.show();
                } else {
                    $groupsToFilter.hide().each(function () {
                        const $el = $(this);

                        if ($el.data("anchorid") === filterId) {
                            $el.show();
                        }
                    });
                }
            }
        });
    }

    // video play/pause controls
    var $manualVideos = $(".js-pd-video-player");

    if ($manualVideos.length) {
        $(".js-pd-video-player-button").on("click", function () {
            var $videoButton = $(this);
            var $video = $videoButton.closest(".js-pd-video-player").find("video");

            if ($video.length) {
                var videoEl = $video.get(0);

                if (videoEl.paused == true) {
                    videoEl.play();
                    $videoButton.find(".pd-category-tile-item__video-button__icon").addClass("d-none");
                } else {
                    videoEl.pause();
                    $videoButton.find(".pd-category-tile-item__video-button__icon").removeClass("d-none");
                }
            }
        });

        // when video source is changed, we need to check the custom play icon status
        window.addEventListener("resize", debounce(() => {
            $manualVideos.each(function () {
                var $video = $(this).find("video");
                var $videoButtonIcon = $(this).find(".pd-category-tile-item__video-button__icon");

                if ($video.length) {
                    var videoEl = $video.get(0);

                    if (videoEl.paused == true) {
                        $videoButtonIcon.removeClass("d-none");
                    } else {
                        $videoButtonIcon.addClass("d-none");
                    }
                }
            });
        }), 100);
    }

    if ($(".c-anniversary-secondary-banner").length) {
        processInclude(require("./components/anniversarySecondaryBanner"));
    }
});

$(".experience-layouts-column").contents().unwrap();
